import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('./views/HomeView.vue')
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('./views/OrderView.vue')
  },
  {
    path: '/goods',
    name: 'goods',
    component: () => import('./views/GoodsView.vue')
  },
  {
    path: '/operation',
    name: 'operation',
    component: () => import('./views/OperationView.vue')
  },
  {
    path: '/empty',
    name: 'empty',
    component: () => import('./views/EmptyView.vue')
  },
  {
    path: '/login/:code',
    name: 'login',
    component: () => import('./views/LoginView.vue')
  },
  {
    path: '/login/expire',
    name: 'loginexpire',
    component: () => import('./views/LoginExpireView.vue')
  },
  {
    path: '/test/ironchoi',
    name: 'test',
    component: () => import('./views/TestView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router